import { fetchBodyCacheStatusCoordinated } from "@/lib/mail/bodyCacheStatusCoordinator";
import { patchFolderSnapshotBodyCached } from "@/lib/mail/inboxFolderBus";

/** Relit DD02 pour le dossier courant et aligne le snapshot (pas de reload liste). */
export async function reconcileVisibleBodyFlags(params: {
  accountId: number;
  folder: string;
  uids: number[];
  force?: boolean;
}): Promise<Map<number, boolean> | null> {
  const res = await fetchBodyCacheStatusCoordinated({
    accountId: params.accountId,
    folder: params.folder,
    uids: params.uids,
    force: params.force,
  });
  if (!res.ok) return null;

  const next = new Map<number, boolean>();
  const ready: number[] = [];
  for (const [key, value] of Object.entries(res.data.flags ?? {})) {
    const uid = Number(key);
    if (uid < 1) continue;
    const cached = value === true;
    next.set(uid, cached);
    if (cached) ready.push(uid);
  }
  if (ready.length > 0) {
    patchFolderSnapshotBodyCached(params.accountId, params.folder, ready);
  }
  return next;
}
